
import { computed } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { useStore } from '../../composables/useStore'
import { partnerContactService } from '../../services'

const csvFileProperties = {
  name: 'partner-contact.csv',
  full_path: '/assets/csv/partner-contact.csv',
}
export default {
  name: 'CImportPartnerContact',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()

    const partnerContactImportInformation = computed(() => {
      return store.getters.partnerContactImportInformation
    })
    const distributorId = computed(() => {
      return store.getters.cooperativeId
    })
    const partner = computed(() => {
      return store.getters.cooperative
    })

    const importInformation = computed(() => {
      return {
        count: partnerContactImportInformation.value?.customerContactsCount,
        lastImportAt: partnerContactImportInformation.value?.lastCustomerContactsImportAt,
      }
    })

    function afterPartnerContactImport() {
      store.dispatch('setPartnerContactImportInformation')
    }

    function downloadCSV() {
      return partnerContactService.downloadPartnerContact(distributorId.value, partner.value.name)
    }

    return {
      afterPartnerContactImport,
      csvProperties: csvFileProperties,
      downloadCSV,
      importInformation,
      partner,
      partnerContactService,
      distributorId,
      partnerContactImportInformation,
    }
  },
}
